import classnames from 'classnames';
import { RoutePathname } from 'frontend/enums';
import React from 'react';
import styles from './SearchResultWrappers.module.css';
import { useRouter } from 'next/router';
type Children = {
  children: React.ReactNode;
};
export const FiltersWrapper = ({
  children
}: Children) => {
  const router = useRouter();
  const isOnSubSubjectPage = router.pathname === RoutePathname.SUBJECT && router.query.subjectPath?.length === 2;
  return <div className={classnames(styles.filtersWrapper, {
    [`${styles.filtersWrapperSubSubject}`]: isOnSubSubjectPage
  })} data-sentry-component="FiltersWrapper" data-sentry-source-file="SearchResultWrappers.tsx">
      {children}
    </div>;
};
export const Divider = () => <hr className={styles.divider} data-sentry-component="Divider" data-sentry-source-file="SearchResultWrappers.tsx" />;
export const SortWrapperForMobile = ({
  children
}: Children) => <div data-testid="mobileSort" className={styles.sortWrapperForMobile} data-sentry-component="SortWrapperForMobile" data-sentry-source-file="SearchResultWrappers.tsx">
    {children}
  </div>;
export const ResultListWrapper = ({
  children,
  ...delegated
}: Children) => <div className={styles.resultsListWrapper} {...delegated} data-sentry-component="ResultListWrapper" data-sentry-source-file="SearchResultWrappers.tsx">
    {children}
  </div>;